import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../types.ts';

const selectUI = (state: RootState) => state.ui;

export const selectActiveTour = createSelector([selectUI], (ui) => ui.activeTour);

const selectAnalysisTourIndex = createSelector([selectUI], (ui) => ui.analysisTourIndex);

export const selectActiveTourIndex = createSelector(
  [selectActiveTour, selectAnalysisTourIndex],
  (activeTour, analysisTourIndex) => {
    switch (activeTour) {
      case 'analysisTour':
        return analysisTourIndex;
      default:
        return -1;
    }
  },
);

export const selectActiveDepreciateSeparatelyID = createSelector(
  [selectUI],
  (ui) => ui.activeDepreciateSeparatelyID,
);

export const selectDeviceWidth = createSelector([selectUI], (ui) => ui.deviceWidth);

export const selectObjectiveEditMode = createSelector([selectUI], (ui) => ui.objectiveEditMode);

export const selectPropertyGridExpandedPropertyIds = createSelector(
  [selectUI],
  (ui) => ui.propertyGridExpandedPropertyIds,
);

export const selectFeatureGridActiveConflictedFields = createSelector(
  [selectUI],
  (ui) => ui.featureGridActiveConflictedFields,
);

export const selectFeatureGridConflictedFields = createSelector(
  [selectUI],
  (ui) => ui.featureGridConflictedFields,
);

export const selectSelectedPriorSalesPropertyId = createSelector(
  [selectUI],
  (ui) => ui.selectedPriorSalesPropertyId,
);

export const selectAivArvActiveTab = createSelector([selectUI], (ui) => ui.aivArvActiveTab);

export const selectEscalationBypassed = createSelector([selectUI], (ui) => ui.escalationBypassed);

export const selectFocusedPropertyGridCellKey = createSelector(
  [selectUI],
  (ui) => ui.focusedPropertyGridCellKey,
);

export const selectPropertyGridCellKeyPendingActivation = createSelector(
  [selectUI],
  (ui) => ui.propertyGridCellKeyPendingActivation,
);

export const selectFocusedOrderDetailsFieldKey = createSelector(
  [selectUI],
  (ui) => ui.focusedOrderDetailsFieldKey,
);

export const selectFocusedCostApproachPropertyId = createSelector(
  [selectUI],
  (ui) => ui.focusedCostApproachPropertyId,
);

export const selectTriggeredAlerts = createSelector([selectUI], (ui) => ui.triggeredAlerts);

export const selectToastSuppressedAlertTypes = createSelector(
  [selectUI],
  (ui) => ui.toastSuppressedAlertTypes,
);

export const selectPendingNavBlockToastTypes = createSelector(
  [selectUI],
  (ui) => ui.pendingNavBlockToastTypes,
);

export const selectTriggeredAlertsCountBySection = createSelector(
  [selectUI],
  (ui) => ui.triggeredAlertsCountBySection,
);
